import { __extends } from "tslib";
import { AssetEvent, LoaderEvent, AssetLibrary, URLRequest, URLLoaderEvent, RequestAnimationFrame, AudioManager, CoordinateSystem, ColorUtils, Loader, WaveAudioParser, EventDispatcher, } from '@awayjs/core';
import { DisplayObjectContainer, SceneGraphPartition, FrameScriptManager, MouseManager, } from '@awayjs/scene';
import { BitmapImage2D, Image2DParser, TouchPoint } from '@awayjs/stage';
import { PickGroup, View } from '@awayjs/view';
import { RendererType, RenderGroup } from '@awayjs/renderer';
import { MovieClipSoundsManager } from './factories/timelinesounds/MovieClipSoundsManager';
import { StageScaleMode } from './factories/as3webFlash/display/StageScaleMode';
import { StageAlign } from './factories/as3webFlash/display/StageAlign';
import { AVMTestHandler } from './AVMTestHandler';
import { SWFParser } from './parsers/SWFParser';
import { AVMEvent } from './AVMEvent';
var AVMStage = /** @class */ (function (_super) {
    __extends(AVMStage, _super);
    function AVMStage(gameConfig) {
        var _this = _super.call(this) || this;
        _this._gameConfig = null;
        _this._curFile = null;
        if (AVMStage._instance)
            throw ('Only one AVMStage is allowed to be constructed');
        AVMStage._instance = _this;
        Loader.enableParsers([WaveAudioParser, SWFParser, Image2DParser]);
        _this._time = 0;
        _this._currentFps = 0;
        _this._avmHandlers = {};
        _this._stageWidth = 550;
        _this._stageHeight = 400;
        _this._scaleMode = StageScaleMode.SHOW_ALL;
        _this._align = StageAlign.TOP_LEFT;
        _this._scaleModeAllowUpdate = true;
        _this._alignAllowUpdate = true;
        if (gameConfig.stageScaleMode) {
            _this._scaleMode = gameConfig.stageScaleMode;
            _this._scaleModeAllowUpdate = false;
        }
        if (gameConfig.stageAlign) {
            _this._align = gameConfig.stageAlign;
            _this._alignAllowUpdate = false;
        }
        if (gameConfig.forceINT) {
            AVMStage.forceINT = gameConfig.forceINT;
        }
        _this._frameRate = 30;
        _this._showFrameRate = false;
        _this._showFrameRateIntervalID = -1;
        _this._x = gameConfig.x ? gameConfig.x : 0;
        _this._y = gameConfig.y ? gameConfig.y : 0;
        _this._w = gameConfig.w ? gameConfig.w : '100%';
        _this._h = gameConfig.h ? gameConfig.h : '100%';
        _this._isPaused = false;
        _this._gameConfig = gameConfig;
        // init awayengine
        _this.initAwayEninge();
        _this._renderer.view.backgroundColor = 0xffffff;
        //this._stage3Ds[this._stage3Ds.length]=new AwayStage(null, );
        AudioManager.setVolume(1);
        // resize event listens on window
        _this._resizeCallbackDelegate = function (event) { return _this.resizeCallback(event); };
        window.addEventListener('resize', _this._resizeCallbackDelegate);
        _this._onLoaderStartDelegate = function (event) { return _this.onLoaderStart(event); };
        _this._onLoaderCompleteDelegate = function (event) { return _this.onLoaderComplete(event); };
        _this._onAssetCompleteDelegate = function (event) { return _this._onAssetComplete(event); };
        _this._onLoadErrorDelegate = function (event) { return _this._onLoadError(event); };
        if (_this._gameConfig.testConfig) {
            _this.avmTestHandler = new AVMTestHandler(_this._gameConfig.testConfig, _this);
        }
        document.addEventListener('fullscreenchange', _this.onFullscreenChanged.bind(_this));
        return _this;
    }
    AVMStage.instance = function () {
        if (!AVMStage._instance)
            throw ('AVMStage._instance should exists but does not');
        return AVMStage._instance;
    };
    Object.defineProperty(AVMStage.prototype, "root", {
        get: function () {
            return this._root;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "view", {
        get: function () {
            return this._view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "mousePicker", {
        get: function () {
            return this._mousePicker;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "mouseManager", {
        get: function () {
            return this._mouseManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "config", {
        get: function () {
            return this._gameConfig;
        },
        enumerable: true,
        configurable: true
    });
    AVMStage.prototype.registerAVMStageHandler = function (value) {
        this._avmHandlers[value.avmVersion] = value;
    };
    Object.defineProperty(AVMStage.prototype, "displayState", {
        get: function () {
            return this._displayState;
        },
        set: function (v) {
            var _this = this;
            if (!document.fullscreenEnabled) {
                this._displayState = "normal" /* NORMAL */;
                return;
            }
            switch (v) {
                case "fullScreenInteractive" /* FULL_SCREEN_INTERACTIVE */:
                case "fullScreen" /* FULL_SCREEN */:
                    if (Element.prototype.requestFullscreen) {
                        document.body.requestFullscreen().then(function () {
                            _this._displayState = v;
                        });
                    }
                    break;
                default:
                    this._displayState = v;
                    if (document.fullscreenElement) {
                        document.exitFullscreen();
                    }
            }
        },
        enumerable: true,
        configurable: true
    });
    AVMStage.prototype.onFullscreenChanged = function (e) {
        if (!document.fullscreenElement) {
            this._displayState = "normal" /* NORMAL */;
        }
    };
    AVMStage.prototype.initAwayEninge = function () {
        //create the partition
        this._root = new DisplayObjectContainer();
        this._partition = new SceneGraphPartition(this._root, true);
        this._root.partition = this._partition;
        this._view = new View();
        this._view.projection.transform.moveTo(0, 0, -1000);
        this._pickGroup = PickGroup.getInstance(this._view);
        this._mousePicker = this._pickGroup.getRaycastPicker(this._partition);
        this._mousePicker.shapeFlag = true;
        this._mouseManager = MouseManager.getInstance(this._view.stage);
        this._renderer = RenderGroup.getInstance(this._view, RendererType.DEFAULT).getRenderer(this._partition);
        this._rendererStage = this._view.stage;
        this._rendererStage.container.style.visibility = 'hidden';
        this._rendererStage.antiAlias = 0;
        this._renderer.renderableSorter = null; //new RenderableSort2D();
        this._projection = this._view.projection;
        this._projection.coordinateSystem = CoordinateSystem.RIGHT_HANDED;
        this._projection.originX = -1;
        this._projection.originY = 1;
        this._projection.fieldOfView = Math.atan(window.innerHeight / 1000 / 2) * 360 / Math.PI;
    };
    AVMStage.prototype.playSWF = function (buffer, url) {
        var _this = this;
        this._gameConfig = {
            files: [{ data: buffer, path: url, resourceType: "GAME" /* GAME */ }],
        };
        this.addEventListener(LoaderEvent.LOADER_COMPLETE, function (e) { return _this.play(); });
        this.loadNextResource();
    };
    AVMStage.prototype.snapshot = function (callback) {
        var myBitmap = new BitmapImage2D(this._stageWidth, this._stageHeight, true, 0xffffffff, false);
        this._renderer.queueSnapshot(myBitmap);
        this._renderer.view.target = myBitmap;
        this._renderer.render();
        this._renderer.view.target = null;
        myBitmap.invalidate();
        // flip vertical:
        var oldData = myBitmap.data;
        var myBitmap2 = new BitmapImage2D(this._stageWidth, this._stageHeight, true, 0xff00ffff, false);
        var x = 0;
        var y = 0;
        var idx = 0;
        var color = 0;
        for (y = 0; y < this._stageHeight; y++) {
            for (x = 0; x < this._stageWidth; x++) {
                idx = ((this._stageHeight - 1 - y) * this._stageWidth + x) * 4;
                color = ColorUtils.ARGBtoFloat32(oldData[idx + 3], oldData[idx], oldData[idx + 1], oldData[idx + 2]);
                myBitmap2.setPixel32(x, y, color);
            }
        }
        myBitmap2.invalidate();
        var htmlCanvas = document.createElement('canvas');
        htmlCanvas.width = myBitmap2.width;
        htmlCanvas.height = myBitmap2.height;
        /*htmlCanvas.style.position = "absolute";
        htmlCanvas.style.top = "0px";
        htmlCanvas.style.left = "0px";
        htmlCanvas.style.width = "100%";*/
        var context = htmlCanvas.getContext('2d');
        var imageData = context.getImageData(0, 0, myBitmap2.width, myBitmap2.height);
        imageData.data.set(myBitmap2.data);
        context.putImageData(imageData, 0, 0);
        if (callback)
            callback(htmlCanvas);
    };
    AVMStage.prototype.loadNextResource = function (event) {
        var _this = this;
        if (event === void 0) { event = null; }
        this._curFile = this._gameConfig.files.shift();
        if (this._curFile) {
            var parser_1 = new SWFParser();
            parser_1._iFileName = this._curFile.path;
            if (this._curFile.resourceType == "GAME" /* GAME */) {
                if (this._swfFile) {
                    throw 'Only playing of 1 SWF file is supported at the moment';
                }
                parser_1.onFactoryRequest = function (swfFile) {
                    _this._swfFile = swfFile;
                    _this.frameRate = _this._swfFile.frameRate;
                    // todo: these values should already been modded in the parser:
                    _this.color = ColorUtils.f32_RGBA_To_f32_ARGB(swfFile.backgroundColor);
                    _this.stageWidth = _this._swfFile.bounds.width / 20;
                    _this.stageHeight = _this._swfFile.bounds.height / 20;
                    var avmName = _this._swfFile.useAVM1 ? "AVM1" /* AVM1 */ : "AVM2" /* AVM2 */;
                    _this._avmHandler = _this._avmHandlers[avmName];
                    if (_this.avmTestHandler && !_this.avmTestHandler.config.settings.onlyTraces) {
                        /*if(this._swfFile.useAVM1){
                            // in FP when using the shell.swf, avm1 traces are 1 frame behind
                            // so we mimmic that behavior here
                            this.avmTestHandler.nextFrame();
                        }*/
                        _this.avmTestHandler.setSWF(_this._swfFile);
                    }
                    if (!_this._avmHandler) {
                        throw 'no avm-handler installed for ' + avmName;
                    }
                    _this._avmHandler.init(_this, _this._swfFile, function (hasInit) {
                        parser_1.factory = _this._avmHandler.factory;
                        SWFParser.factory = _this._avmHandler.factory;
                        if (hasInit)
                            _this.dispatchEvent(new AVMEvent(AVMEvent.AVM_COMPLETE, avmName));
                    });
                };
            }
            // Parser will not be provided with factory. DefaultSceneGraphFactory will be used
            AssetLibrary.addEventListener(LoaderEvent.LOADER_START, this._onLoaderStartDelegate);
            AssetLibrary.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
            AssetLibrary.addEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
            AssetLibrary.addEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
            if (this._curFile.data) {
                AssetLibrary.loadData(this._curFile.data, null, this._curFile.path, parser_1);
            }
            else {
                AssetLibrary.load(new URLRequest(this._curFile.path), null, this._curFile.path, parser_1);
            }
        }
        else {
            if (!this._swfFile) {
                throw 'no valid SWFFile was loaded!';
            }
            if (event) {
                this.dispatchEvent(event);
            }
        }
    };
    AVMStage.prototype.load = function () {
        this.loadNextResource();
    };
    AVMStage.prototype.onLoaderStart = function (event) {
        this.dispatchEvent(event);
    };
    AVMStage.prototype._onAssetComplete = function (event) {
        // atm we only addAssets to avmHandler that come from the game swf
        // preloaded files are fonts, and are handled by DefaultManager outside of SWF
        if (this._curFile.resourceType == "GAME" /* GAME */) {
            if (AVMStage.runtimeStartTime == 0) {
                AVMStage.runtimeStartTime = Date.now();
            }
            this._avmHandler.addAsset(event.asset, true);
        }
        this.dispatchEvent(event);
    };
    AVMStage.prototype.onLoaderComplete = function (event) {
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        this.loadNextResource(event);
    };
    AVMStage.prototype._onLoadError = function (event) {
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        console.log('error loading swf');
        this.dispatchEvent(event);
    };
    AVMStage.prototype.play = function (offset) {
        if (offset === void 0) { offset = 0; }
        // start the main_loop:
        this.resizeCallback(null);
        this._timer = new RequestAnimationFrame(this.main_loop, this);
        this._timer.start();
        var rootMC = this._root;
        if (!rootMC) {
            console.warn('warning: AVMPlayer.play called, but no scene is loaded');
            return;
        }
        if (offset) {
            rootMC.currentFrameIndex = offset;
        }
        // manually move playhead to next frame, so we immediatly render something
        this.showNextFrame(0);
        this._rendererStage.container.style.visibility = 'visible';
    };
    AVMStage.prototype.updateFPS = function () {
        this._fpsTextField.style.visibility = (!this._currentFps || !this._frameRate) ? 'hidden' : 'visible';
        this._fpsTextField.innerText = this._currentFps.toFixed(2) + '/' + this._frameRate + ' fps';
        this._currentFps = 0;
    };
    AVMStage.prototype.setStageDimensions = function (x, y, w, h) {
        this._x = x;
        this._y = y;
        this._w = w;
        this._h = h;
        this.resizeStageInternal();
    };
    AVMStage.prototype.resizeStageInternal = function () {
        var x = typeof this._x === 'string'
            ? (parseFloat(this._x.replace('%', '')) / 100) * window.innerWidth
            : this._x;
        var y = typeof this._y === 'string'
            ? (parseFloat(this._y.replace('%', '')) / 100) * window.innerHeight
            : this._y;
        var w = typeof this._w === 'string'
            ? (parseFloat(this._w.replace('%', '')) / 100) * window.innerWidth
            : this._w;
        var h = typeof this._h === 'string'
            ? (parseFloat(this._h.replace('%', '')) / 100) * window.innerHeight
            : this._h;
        var newX = x;
        var newY = y;
        var newWidth = w;
        var newHeight = h;
        // todo: correctly implement all StageScaleModes;
        switch (this._scaleMode) {
            case StageScaleMode.NO_SCALE:
                this._projection.fieldOfView = Math.atan(h / 1000 / 2) * 360 / Math.PI;
                this._stageWidth = w;
                this._stageHeight = h;
                break;
            case StageScaleMode.SHOW_ALL:
                newHeight = h;
                newWidth = (this._stageWidth / this._stageHeight) * newHeight;
                if (newWidth > w) {
                    newWidth = w;
                    newHeight = newWidth * (this._stageHeight / this._stageWidth);
                }
                newX += (w - newWidth) / 2;
                newY += (h - newHeight) / 2;
                this._projection.fieldOfView = (Math.atan(this._stageHeight / 1000 / 2) * 360) / Math.PI;
                break;
            case StageScaleMode.EXACT_FIT:
            case StageScaleMode.NO_BORDER:
                this._projection.fieldOfView = (Math.atan(h / 1000 / 2) * 360) / Math.PI;
                break;
            default:
                console.log('Stage: only implemented StageScaleMode are NO_SCALE, SHOW_ALL');
                break;
        }
        // todo: correctly implement all alignModes;
        switch (this._align) {
            case StageAlign.TOP_LEFT:
                this._view.x = newX;
                this._view.y = newY;
                break;
            default:
                this._view.x = newX;
                this._view.y = newY;
                console.log('Stage: only implemented StageAlign is TOP_LEFT');
                break;
        }
        this._view.x = newX;
        this._view.y = newY;
        this._view.width = newWidth;
        this._view.height = newHeight;
        if (this._fpsTextField)
            this._fpsTextField.style.left = (window.innerWidth * 0.5 - 50 + 'px');
        if (this._avmHandler) {
            this._avmHandler.resizeStage();
        }
    };
    AVMStage.prototype.resizeCallback = function (event) {
        if (event === void 0) { event = null; }
        this.resizeStageInternal();
    };
    AVMStage.prototype.pause = function () {
        AudioManager.setVolume(0);
        this._isPaused = true;
    };
    AVMStage.prototype.unPause = function () {
        AudioManager.setVolume(1);
        this._isPaused = false;
    };
    Object.defineProperty(AVMStage.prototype, "isPaused", {
        get: function () {
            return this._isPaused;
        },
        set: function (value) {
            this._isPaused = value;
        },
        enumerable: true,
        configurable: true
    });
    AVMStage.prototype.main_loop = function (dt) {
        if (this._isPaused) {
            return;
        }
        if (!this._avmHandler) {
            throw ('error - can not render when no avm-stage is available');
        }
        var frameMarker = Math.floor(1000 / this._frameRate);
        this._time += Math.min(dt, frameMarker);
        if (this._time >= frameMarker) {
            this._currentFps++;
            this.showNextFrame(this._time);
            this._time -= frameMarker;
        }
    };
    AVMStage.prototype.requestRender = function () {
        FrameScriptManager.execute_queue();
        this._renderer.render();
    };
    AVMStage.prototype.showNextFrame = function (dt) {
        if (this._isPaused) {
            MovieClipSoundsManager.enterFrame();
            MovieClipSoundsManager.exitFrame();
            return;
        }
        MovieClipSoundsManager.enterFrame();
        if (this.avmTestHandler)
            this.avmTestHandler.dispatchEvents();
        this._mouseManager.fireMouseEvents(this._mousePicker);
        this._avmHandler.enterFrame(dt);
        if (this.avmTestHandler)
            this.avmTestHandler.nextFrame();
        this._renderer.render();
        MovieClipSoundsManager.exitFrame();
    };
    Object.defineProperty(AVMStage.prototype, "align", {
        get: function () {
            return this._align;
        },
        set: function (value) {
            if (!this._alignAllowUpdate)
                return;
            this._align = value;
            this.resizeCallback();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "accessibilityImplementation", {
        get: function () {
            console.log('AVMStage: get accessibilityImplementation not implemented');
            return this._align;
        },
        set: function (value) {
            //todo: any is AccessibilityImplementation
            console.log('AVMStage:  accessibilityImplementation not implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "color", {
        get: function () {
            return this._renderer.view.backgroundColor;
        },
        set: function (value) {
            this._renderer.view.backgroundColor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "frameRate", {
        get: function () {
            return this._frameRate;
        },
        set: function (value) {
            this._frameRate = value;
        },
        enumerable: true,
        configurable: true
    });
    AVMStage.prototype.getLocalMouseX = function (entity) {
        return entity
            .transform
            .inverseConcatenatedMatrix3D
            .transformVector(this._renderer.view.unproject(this._view.stage.screenX, this._view.stage.screenY, 1000))
            .x;
    };
    AVMStage.prototype.getLocalMouseY = function (entity) {
        return entity
            .transform
            .inverseConcatenatedMatrix3D
            .transformVector(this._renderer.view.unproject(this._view.stage.screenX, this._view.stage.screenY, 1000))
            .y;
    };
    AVMStage.prototype.getLocalTouchPoints = function (entity) {
        var localPosition;
        var localTouchPoints = new Array();
        var len = this._view.stage.touchPoints.length;
        for (var i = 0; i < len; i++) {
            localPosition = entity
                .transform
                .inverseConcatenatedMatrix3D
                .transformVector(this._renderer.view.unproject(this._view.stage.touchPoints[i].x, this._view.stage.touchPoints[i].y, 1000));
            localTouchPoints.push(new TouchPoint(localPosition.x, localPosition.y, this._view.stage.touchPoints[i].id));
        }
        return localTouchPoints;
    };
    Object.defineProperty(AVMStage.prototype, "scaleMode", {
        get: function () {
            return this._scaleMode;
        },
        set: function (value) {
            if (!this._scaleModeAllowUpdate)
                return;
            this._scaleMode = value;
            this.resizeCallback();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "showFrameRate", {
        get: function () {
            return this._showFrameRate;
        },
        set: function (value) {
            var _this = this;
            if (value == this._showFrameRate)
                return;
            this._showFrameRate = value;
            if (value) {
                // todo: better make this a class that can show more info (like num of drawcalls etc)
                this._fpsTextField = document.createElement('div'); // disable in RC
                this._fpsTextField.style.cssFloat = 'none';
                this._fpsTextField.style.backgroundColor = '#000';
                this._fpsTextField.style.position = 'fixed';
                this._fpsTextField.style.top = '5px';
                this._fpsTextField.style.width = '100px';
                this._fpsTextField.style.height = '20px';
                this._fpsTextField.style.right = '5px';
                this._fpsTextField.style.textAlign = 'center';
                this._fpsTextField.style.color = '#ffffff';
                this._fpsTextField.style.fontSize = '16';
                this._fpsTextField.style.visibility = 'hidden';
                this._fpsTextField.innerHTML = '';
                document.body.appendChild(this._fpsTextField);
                this._showFrameRateIntervalID = setInterval(function () { return _this.updateFPS(); }, 1000);
            }
            else {
                if (this._showFrameRateIntervalID) {
                    clearInterval(this._showFrameRateIntervalID);
                    this._showFrameRateIntervalID = -1;
                    document.body.removeChild(this._fpsTextField);
                    this._fpsTextField = null;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "stageHeight", {
        get: function () {
            return this._stageHeight;
        },
        set: function (value) {
            this._stageHeight = value;
            this.resizeCallback();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "stageWidth", {
        get: function () {
            return this._stageWidth;
        },
        set: function (value) {
            this._stageWidth = value;
            this.resizeCallback();
        },
        enumerable: true,
        configurable: true
    });
    AVMStage.runtimeStartTime = 0;
    AVMStage._instance = null;
    AVMStage.forceINT = false;
    return AVMStage;
}(EventDispatcher));
export { AVMStage };
